(function () {
  const TRIGGER_VARIANT_ID = 48245071544577; // ARES Pure
  const GIFT_VARIANT_ID = 48671560728833;    // Jersey Promo
  const MIN_QTY = 2;

  let isUpdating = false;
  let isRefreshing = false;
  let lastHandledState = null;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
      })
    });
  }

  async function removeGift(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });
  }

  function refreshCartPage() {
    if (isRefreshing) return;
    isRefreshing = true;

    setTimeout(() => {
      window.location.reload();
    }, 700);
  }

  function showGiftMessage(type = 'added') {
    const existing = document.querySelector('.auto-gift-toast');
    if (existing) existing.remove();

    const el = document.createElement('div');
    el.className = 'auto-gift-toast';

    el.innerHTML =
      type === 'added'
        ? '🎁 ¡Regalo agregado automáticamente!'
        : '❌ El regalo fue removido';

    document.body.appendChild(el);

    setTimeout(() => el.classList.add('show'), 50);

    setTimeout(() => {
      el.classList.remove('show');
      setTimeout(() => el.remove(), 300);
    }, 3000);
  }

 function updateGiftBar(aresQty) {
  let bar = document.querySelector('.auto-gift-bar');

  if (!bar) {
    bar = document.createElement('div');
    bar.className = 'auto-gift-bar';
    document.body.appendChild(bar);
  }

  // 🔴 0 productos → no mostrar
  if (aresQty === 0) {
    bar.classList.remove('active');
    return;
  }

  // 🟡 1 producto → incentivo
  if (aresQty === 1) {
    bar.innerHTML = '🎁 Te falta 1 producto para recibir tu regalo';
    bar.classList.add('active');
    return;
  }

  // 🟢 2 o más → éxito
  if (aresQty >= MIN_QTY) {
    bar.innerHTML = '🎉 ¡Ya tienes un regalo gratis en tu carrito!';
    bar.classList.add('active');
  }
}

  function lockGiftItem() {
    const giftVariantId = GIFT_VARIANT_ID.toString();

    // bloquear inputs de cantidad
    document.querySelectorAll('[data-quantity-variant-id]').forEach(input => {
      if (input.dataset.quantityVariantId === giftVariantId) {

        input.setAttribute('readonly', true);
        input.style.pointerEvents = 'none';

        const wrapper = input.closest('quantity-input');
        if (wrapper) {
          wrapper.querySelectorAll('button').forEach(btn => {
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.5';
          });
        }
      }
    });

    // bloquear eliminar
    document.querySelectorAll('cart-remove-button a').forEach(link => {
      if (link.href.includes(GIFT_VARIANT_ID)) {
        link.style.pointerEvents = 'none';
        link.style.opacity = '0.5';
      }
    });
  }

  async function checkCart() {
    if (isUpdating) return;

    const cart = await getCart();

    // ✅ suma correcta (clave)
    const aresQty = cart.items
      .filter(i => i.variant_id === TRIGGER_VARIANT_ID)
      .reduce((total, item) => total + item.quantity, 0);

    const giftItem = cart.items.find(i => i.variant_id === GIFT_VARIANT_ID);

    const currentState = `${aresQty}-${giftItem ? giftItem.quantity : 0}`;

    if (currentState === lastHandledState) return;
    lastHandledState = currentState;

    updateGiftBar(aresQty);
    lockGiftItem();

    isUpdating = true;

    try {
      // 🎁 agregar regalo
      if (aresQty >= MIN_QTY && !giftItem) {
        await addGift();
        showGiftMessage('added');
        refreshCartPage();
      }

      // ❌ remover regalo
      if (aresQty < MIN_QTY && giftItem) {
        await removeGift(giftItem.key);
        showGiftMessage('removed');
        refreshCartPage();
      }

      // 🔥 asegurar solo 1 regalo
      if (giftItem && giftItem.quantity > 1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 1
          })
        });
        refreshCartPage();
      }

    } catch (e) {
      console.error('Auto gift error:', e);
    }

    isUpdating = false;
  }

  function init() {
    setInterval(checkCart, 1500);
  }

  document.addEventListener('DOMContentLoaded', init);
})();